import { enableAkitaProdMode } from '@datorama/akita';
export const environment = {
  production: true,
  API_ENDPOINT: 'https://api.journalocity.com/api/v1',
  SESSION_STORAGE_PREFIX: 'AJKE_',
   webClientUrl: 'https://www.journalocity.com'
};
if (environment.production) {
  enableAkitaProdMode();
}
